import { createReducer } from "@reduxjs/toolkit";
import { PublicViewerState } from "../actions/publicViewer/types";
import { defaultGetResponse } from "../interfaces/ActionReducer/GetMethod/GetResponse";
import {
    allUserClassTypeReceived,
    displayNameMappingReceived,
    getDisplayNameMapping
} from "actions/publicViewer";

const initialState: PublicViewerState = {
    allUserClassType: defaultGetResponse,
    displayNameMappingType: defaultGetResponse,
    isDisplayNameMappingFetched: false
};

const publicViewer = createReducer(initialState, (builder) => {
    builder
        .addCase(allUserClassTypeReceived, (state, action) => {
            state.allUserClassType = action.payload.allUserClassTypeReceived;
        })
        .addCase(getDisplayNameMapping, (state) => {
            state.isDisplayNameMappingFetched = false;
        })
        .addCase(displayNameMappingReceived, (state, action) => {
            state.displayNameMappingType = action.payload.displayNameMappingReceived;
            state.isDisplayNameMappingFetched = true;
        })
        .addDefaultCase((state) => state);
});

export default publicViewer;
